// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ego6","delete":"styles_delete__yAPEr","update":"styles_update__2gWg5","add":"styles_add__2Dg9y"};